import { combineReducers } from "redux";

// Import reducers as they are created
import libraryCardReducer from "./libraryCardReducer";

const rootReducer = combineReducers({
  libraryCards: libraryCardReducer,
  // Add more reducers as needed (revenue lines, products, etc.)
});

export default rootReducer;
